module.exports = __webpack_public_path__ + "images/shadow-of-the-colossus_rgba(0,0,0,0.7).jpg?v=84ac3de2793f49cfddda7796cf80603b";